import React from 'react';
import { Modal, Container, Row } from 'reactstrap';
import { Input } from 'antd';

import { ApiContext } from 'src/utils/ApiContext';

export default (props) => {
  const { onWithdraw } = props;

  const context = React.useContext(ApiContext);

  const withdrawOptions = [
    { label: '提現(有 RemitLink)', callback: true, testFail: false, className: 'btn-info' },
    { label: '提現(無 RemitLink)', callback: false, testFail: false, className: 'btn-info' },
    { label: '提現失敗(有 RemitLink)', callback: true, testFail: true, className: 'btn-danger' },
    // { label: '提現失敗(無 RemitLink)', callback: false, testFail: true, className: 'btn-danger' },
  ];

  return (
    <Modal
      isOpen={context.showWithdraw}
      toggle={() => context.setShowWithdraw(false)}
      zIndex={1}
    >
      <Container style={{ padding: 20, background: '#1E3845' }}>
        <Row className={'justify-content-center align-items-center'}>
          <div style={{ color: 'whitesmoke' }}>{'請選擇提現的金額'}</div>
        </Row>

        <div style={{ display: 'grid', gap: '10px' }}>
          <Input
            prefix={'$'}
            suffix={context.symbol}
            value={context.coinValue}
            onChange={(e) => context.setCoinValue(e.target.value)}
          />

          {withdrawOptions.map(({ label, callback, testFail, className }) => (
            <button
              key={label}
              className={`btn ${className}`}
              onClick={() =>
                onWithdraw({ amount: context.coinValue, callback, testFail })
              }
            >
              {label}
            </button>
          ))}

        </div>
      </Container>
    </Modal>
  );
};
